import React from 'react';

import './AdSetDAAPopUp.css';

const AdSetDAAPopUp = (props) => {
  const { adset } = props;
  const {
    adSetName,
    daaType,
    includeLocation,
    includeAudience,
    includeTargeting,
    selectedAudiences
  } = adset || {};
  return props.adset ? (
    <div>
      <ul className="adset-daa-list-popup">
        <li>
          <b className="adset-daa-list-title">Name:</b>
          {adSetName}
        </li>
        <li>
          <b className="adset-daa-list-title">DAA Type:</b>
          {daaType}
        </li>
        <li>
          <b className="adset-daa-list-title">Include Location:</b>
          {includeLocation ? 'Include' : 'Do not Include'}
        </li>
        <li>
          <b className="adset-daa-list-title">Include Audience:</b>
          {includeAudience ? 'Include' : 'Do not Include'}
        </li>
        <li>
          <b className="adset-daa-list-title">Include Targeting:</b>
          {includeTargeting ? 'Include' : 'Do not Include'}
        </li>
        <li>
          <b className="adset-daa-list-title">Include Targeting:</b>
          {includeTargeting ? 'Include' : 'Do not Include'}
        </li>
        {selectedAudiences && selectedAudiences.length > 0 && (
          <li>
            <b className="adset-list-title">Audiences:</b>
            {selectedAudiences.map((audience) => audience.text).join(',')}
          </li>
        )}
      </ul>
    </div>
  ) : null;
};

export default AdSetDAAPopUp;



// WEBPACK FOOTER //
// ./src/screens/PackageBuilder/AdSetDAAPopUp.js